/**
 * What each country calls itself, in its own language, pointed at the name this site uses.
 *
 * Generated by scripts/generate-endonyms.mjs from the world-countries package — do not edit
 * by hand. Run `npm run generate:endonyms` to rebuild it; endonyms.test.ts fails while the
 * file and the installed package disagree.
 *
 * A name here resolved to nothing before this table existed, so a row can only add an
 * answer. The generator drops any that would do more than that: a name already spelled for
 * by `countryAliases`, a name that already means a different country, and a name two
 * countries share. Those are listed below rather than dropped quietly, because the ones
 * worth arguing about are the ones that are missing.
 *
 * Only the common name in each native language is here, not the official one: nobody
 * addresses a postcard to the Bundesrepublik Deutschland.
 *
 * Names in the source this table does not answer for:
 *   Bouvet Island (Bouvet Island) — no coordinate for the country itself
 *   Heard Island and McDonald Islands (Heard Island and McDonald Islands) — no coordinate for the country itself
 *   Saint-Martin (Sint Maarten) — already the name of "saint martin"
 *
 * And the half of #47 that stays open. The source names these 47 countries only in a script
 * the fold cannot keep, so what they call themselves folds to the empty string: skipped by
 * the map, counted in no stat, minting no link. Closing that means changing the fold —
 * transliterating, or matching on the letters themselves — not adding rows here.
 *
 * Two of them are reachable anyway, and not through this file: Serbia and Montenegro are
 * digraphic, the source records only the Cyrillic name, and `countryAliases` carries the
 * Latin one by hand. They are still counted here, because what is counted is what the
 * source can say.
 *   Algeria, Armenia, Bahrain, Bangladesh, Belarus, Bhutan, Bulgaria, China, Egypt, Ethiopia,
 *   Georgia, Greece, Iran, Iraq, Israel, Japan, Jordan, Kazakhstan, Kuwait, Kyrgyzstan, Laos,
 *   Libya, Maldives, Mauritania, Mongolia, Montenegro, Morocco, Myanmar, Nepal, North Korea,
 *   North Macedonia, Oman, Palestine, Qatar, Russia, Saudi Arabia, Serbia, South Korea,
 *   Sri Lanka, Syria, Taiwan, Tajikistan, Thailand, Tunisia, Ukraine, United Arab Emirates,
 *   Yemen.
 */
export const endonyms = {
  source: {
    package: "world-countries",
    version: "5.1.0",
    // The data is mledoze/countries, licensed ODbL-1.0.
    license: "ODbL-1.0",
  },
  countries: {
    "aforika borwa": "south africa", // Aforika Borwa (tsn)
    "afrika borwa": "south africa", // Afrika Borwa (sot)
    "afrika dzonga": "south africa", // Afrika Dzonga (tso)
    "afurika tshipembe": "south africa", // Afurika Tshipembe (ven)
    "aotearoa": "new zealand", // Aotearoa (mri)
    "ayiti": "haiti", // Ayiti (hat)
    "azerbaycan": "azerbaijan", // Azərbaycan (aze)
    "beafrika": "central african republic", // Bêafrîka (sag)
    "belau": "palau", // Belau (pau)
    "belgie": "belgium", // België (nld)
    "belgien": "belgium", // Belgien (deu)
    "belgique": "belgium", // Belgique (fra)
    "belice": "belize", // Belice (spa)
    "boneiru sint eustatius y saba": "bonaire sint eustatius and saba", // Boneiru, Sint Eustatius y Saba (pap)
    "bosna i hercegovina": "bosnia and herzegovina", // Bosna i Hercegovina (hrv)
    "brasil": "brazil", // Brasil (por)
    "buliwya": "bolivia", // Buliwya (que)
    "cameroun": "cameroon", // Cameroun (fra)
    "caribisch nederland": "bonaire sint eustatius and saba", // Caribisch Nederland (nld)
    "cesko": "czechia", // Česko (slk)
    "comores": "comoros", // Comores (fra)
    "danmark": "denmark", // Danmark (dan)
    "deutschland": "germany", // Deutschland (deu)
    "dgernesiais": "guernsey", // Dgèrnésiais (nfr)
    "ditunga dia kongu wa mungalaata": "democratic republic of the congo", // Ditunga dia Kongu wa Mungalaata (lua)
    "eesti": "estonia", // Eesti (est)
    "eire": "ireland", // Éire (gle)
    "espana": "spain", // España (spa)
    "faeroerne": "faroe islands", // Færøerne (dan)
    "foroyar": "faroe islands", // Føroyar (fao)
    "guahan": "guam", // Guåhån (cha)
    "guernesey": "guernsey", // Guernesey (fra)
    "guine bissau": "guinea bissau", // Guiné-Bissau (pov)
    "guine equatorial": "equatorial guinea", // Guiné Equatorial (por)
    "guinea ecuatorial": "equatorial guinea", // Guinea Ecuatorial (spa)
    "guinee": "guinea", // Guinée (fra)
    "guinee equatoriale": "equatorial guinea", // Guinée équatoriale (fra)
    "guyane francaise": "french guiana", // Guyane française (fra)
    "hrvatska": "croatia", // Hrvatska (hrv)
    "island": "iceland", // Ísland (isl)
    "italia": "italy", // Italia (ita)
    "jamhuri ya kidemokrasia ya kongo": "democratic republic of the congo", // Jamhuri ya Kidemokrasia ya Kongo (swa)
    "jerri": "jersey", // Jèrri (nrf)
    "kalaallit nunaat": "greenland", // Kalaallit Nunaat (kal)
    "kampuchea": "cambodia", // Kâmpŭchéa (khm)
    "kibris": "cyprus", // Kıbrıs (tur)
    "komori": "comoros", // Komori (zdj)
    "kosova": "kosovo", // Kosova (sqi)
    "kuki airani": "cook islands", // Kūki 'Āirani (rar)
    "la reunion": "reunion", // La Réunion (fra)
    "latvija": "latvia", // Latvija (lav)
    "letzebuerg": "luxembourg", // Lëtzebuerg (ltz)
    "liban": "lebanon", // Liban (fra)
    "lietuva": "lithuania", // Lietuva (lit)
    "luxemburg": "luxembourg", // Luxemburg (deu)
    "madagasikara": "madagascar", // Madagasikara (mlg)
    "magyarorszag": "hungary", // Magyarország (hun)
    "majel": "marshall islands", // M̧ajeļ (mah)
    "mannin": "isle of man", // Mannin (glv)
    "maurice": "mauritius", // Maurice (fra)
    "mocambique": "mozambique", // Moçambique (por)
    "moris": "mauritius", // Moris (mfe)
    "mzantsi afrika": "south africa", // Mzantsi Afrika (xho)
    "na islas marianas": "northern mariana islands", // Na Islas Mariånas (cha)
    "namibie": "namibia", // Namibië (afr)
    "nederland": "netherlands", // Nederland (nld)
    "negara brunei darussalam": "brunei", // Negara Brunei Darussalam (msa)
    "ningizimu afrika": "south africa", // Ningizimu Afrika (zul)
    "noreg": "norway", // Noreg (nno)
    "norf k ailen": "norfolk island", // Norf'k Ailen (pih)
    "norge": "norway", // Norge (nob)
    "norgga": "norway", // Norgga (smi)
    "nouvelle caledonie": "new caledonia", // Nouvelle-Calédonie (fra)
    "o zbekiston": "uzbekistan", // O‘zbekiston (uzb)
    "osterreich": "austria", // Österreich (bar)
    "owganystan": "afghanistan", // Owganystan (tuk)
    "pais korsou": "curacao", // Pais Kòrsou (pap)
    "papua niugini": "papua new guinea", // Papua Niugini (tpi)
    "paraguai": "paraguay", // Paraguái (grn)
    "pilipinas": "philippines", // Pilipinas (fil)
    "piruw": "peru", // Piruw (que)
    "polska": "poland", // Polska (pol)
    "polynesie francaise": "french polynesia", // Polynésie française (fra)
    "rd congo": "democratic republic of the congo", // RD Congo (fra)
    "repubilika ya kongo": "congo", // Repubilika ya Kongo (kon)
    "repubilika ya kongo demokratiki": "democratic republic of the congo", // Repubilika ya Kongo Demokratiki (kon)
    "republica dominicana": "dominican republic", // República Dominicana (spa)
    "republiki ya kongo": "congo", // Republíki ya Kongó (lin)
    "republiki ya kongo demokratiki": "democratic republic of the congo", // Republiki ya Kongó Demokratiki (lin)
    "republique centrafricaine": "central african republic", // République centrafricaine (fra)
    "republique du congo": "congo", // République du Congo (fra)
    "sahara occidental": "western sahara", // Sahara Occidental (spa)
    "saint pierre et miquelon": "saint pierre and miquelon", // Saint-Pierre-et-Miquelon (fra)
    "samoa amelika": "american samoa", // Sāmoa Amelika (smo)
    "sao tome e principe": "sao tome and principe", // São Tomé e Príncipe (por)
    "schweiz": "switzerland", // Schweiz (gsw)
    "sesel": "seychelles", // Sesel (crs)
    "sewula afrika": "south africa", // Sewula Afrika (nbl)
    "shqiperia": "albania", // Shqipëria (sqi)
    "singapura": "singapore", // Singapura (msa)
    "slovenija": "slovenia", // Slovenija (slv)
    "slovensko": "slovakia", // Slovensko (slk)
    "soomaaliya": "somalia", // Soomaaliya (som)
    "suisse": "switzerland", // Suisse (fra)
    "suomi": "finland", // Suomi (fin)
    "svalbard og jan mayen": "svalbard and jan mayen", // Svalbard og Jan Mayen (nor)
    "sverige": "sweden", // Sverige (swe)
    "svizra": "switzerland", // Svizra (roh)
    "svizzera": "switzerland", // Svizzera (ita)
    "tchad": "chad", // Tchad (fra)
    "terres australes et antarctiques francaises": "french southern and antarctic lands", // Terres australes et antarctiques françaises (fra)
    "uburundi": "burundi", // Uburundi (run)
    "vaticanae": "vatican city", // Vaticanæ (lat)
    "vaticano": "vatican city", // Vaticano (ita)
    "viet nam": "vietnam", // Việt Nam (vie)
    "viti": "fiji", // Viti (fij)
    "volivia": "bolivia", // Volívia (grn)
    "wallis et futuna": "wallis and futuna", // Wallis et Futuna (fra)
    "wuliwya": "bolivia", // Wuliwya (aym)
  } as Readonly<Record<string, string>>,
};

/**
 * Every name in the source no row above answers for, with the rule that dropped it. The
 * docblock summarises this; endonyms.test.ts reads it, so a dropped name cannot quietly
 * become a kept one when the source changes.
 *
 * Its own export rather than a property of `endonyms`, and the same for the list below.
 * Rollup drops an export nothing imports, but not an unread property of an object the app
 * does import — and it does import this module, for `endonyms.countries` alone. As
 * properties these two arrays were 9 KB of the browser bundle that no browser read, which
 * is the cost issue #1 was about.
 */
export const excludedNames: readonly { written: string; country: string; reason: string }[] = [
    { written: "افغانستان", country: "Afghanistan", reason: "not written in the Latin script" },
    { written: "افغانستان", country: "Afghanistan", reason: "not written in the Latin script" },
    { written: "الجزائر", country: "Algeria", reason: "not written in the Latin script" },
    { written: "Հայաստան", country: "Armenia", reason: "not written in the Latin script" },
    { written: "Азербайджан", country: "Azerbaijan", reason: "not written in the Latin script" },
    { written: "البحرين", country: "Bahrain", reason: "not written in the Latin script" },
    { written: "বাংলাদেশ", country: "Bangladesh", reason: "not written in the Latin script" },
    { written: "Белару́сь", country: "Belarus", reason: "not written in the Latin script" },
    { written: "Беларусь", country: "Belarus", reason: "not written in the Latin script" },
    { written: "འབྲུག་ཡུལ་", country: "Bhutan", reason: "not written in the Latin script" },
    { written: "Боснa и Херцеговина", country: "Bosnia and Herzegovina", reason: "not written in the Latin script" },
    { written: "Bouvet Island", country: "Bouvet Island", reason: "no coordinate for the country itself" },
    { written: "България", country: "Bulgaria", reason: "not written in the Latin script" },
    { written: "تشاد", country: "Chad", reason: "not written in the Latin script" },
    { written: "中国", country: "China", reason: "not written in the Latin script" },
    { written: "جزر القمر", country: "Comoros", reason: "not written in the Latin script" },
    { written: "Κύπρος", country: "Cyprus", reason: "not written in the Latin script" },
    { written: "جيبوتي", country: "Djibouti", reason: "not written in the Latin script" },
    { written: "مصر", country: "Egypt", reason: "not written in the Latin script" },
    { written: "إريتريا", country: "Eritrea", reason: "not written in the Latin script" },
    { written: "ኤርትራ", country: "Eritrea", reason: "not written in the Latin script" },
    { written: "ኢትዮጵያ", country: "Ethiopia", reason: "not written in the Latin script" },
    { written: "फिजी", country: "Fiji", reason: "not written in the Latin script" },
    { written: "საქართველო", country: "Georgia", reason: "not written in the Latin script" },
    { written: "Ελλάδα", country: "Greece", reason: "not written in the Latin script" },
    { written: "Heard Island and McDonald Islands", country: "Heard Island and McDonald Islands", reason: "no coordinate for the country itself" },
    { written: "香港", country: "Hong Kong", reason: "not written in the Latin script" },
    { written: "भारत", country: "India", reason: "not written in the Latin script" },
    { written: "இந்தியா", country: "India", reason: "not written in the Latin script" },
    { written: "ایران", country: "Iran", reason: "not written in the Latin script" },
    { written: "العراق", country: "Iraq", reason: "not written in the Latin script" },
    { written: "کۆماری", country: "Iraq", reason: "not written in the Latin script" },
    { written: "ܩܘܼܛܢܵܐ", country: "Iraq", reason: "not written in the Latin script" },
    { written: "ישראל", country: "Israel", reason: "not written in the Latin script" },
    { written: "إسرائيل", country: "Israel", reason: "not written in the Latin script" },
    { written: "日本", country: "Japan", reason: "not written in the Latin script" },
    { written: "الأردن", country: "Jordan", reason: "not written in the Latin script" },
    { written: "Казахстан", country: "Kazakhstan", reason: "not written in the Latin script" },
    { written: "Қазақстан", country: "Kazakhstan", reason: "not written in the Latin script" },
    { written: "Косово", country: "Kosovo", reason: "not written in the Latin script" },
    { written: "الكويت", country: "Kuwait", reason: "not written in the Latin script" },
    { written: "Киргизия", country: "Kyrgyzstan", reason: "not written in the Latin script" },
    { written: "Кыргызстан", country: "Kyrgyzstan", reason: "not written in the Latin script" },
    { written: "ສປປລາວ", country: "Laos", reason: "not written in the Latin script" },
    { written: "لبنان", country: "Lebanon", reason: "not written in the Latin script" },
    { written: "ليبيا", country: "Libya", reason: "not written in the Latin script" },
    { written: "澳门", country: "Macau", reason: "not written in the Latin script" },
    { written: "مليسيا", country: "Malaysia", reason: "not written in the Latin script" },
    { written: "ދިވެހިރާއްޖޭގެ", country: "Maldives", reason: "not written in the Latin script" },
    { written: "موريتانيا", country: "Mauritania", reason: "not written in the Latin script" },
    { written: "Монгол улс", country: "Mongolia", reason: "not written in the Latin script" },
    { written: "Црна Гора", country: "Montenegro", reason: "not written in the Latin script" },
    { written: "المغرب", country: "Morocco", reason: "not written in the Latin script" },
    { written: "ⵍⵎⴰⵖⵔⵉⴱ", country: "Morocco", reason: "not written in the Latin script" },
    { written: "မြန်မာ", country: "Myanmar", reason: "not written in the Latin script" },
    { written: "नेपाल", country: "Nepal", reason: "not written in the Latin script" },
    { written: "조선", country: "North Korea", reason: "not written in the Latin script" },
    { written: "Македонија", country: "North Macedonia", reason: "not written in the Latin script" },
    { written: "عمان", country: "Oman", reason: "not written in the Latin script" },
    { written: "پاكستان", country: "Pakistan", reason: "not written in the Latin script" },
    { written: "فلسطين", country: "Palestine", reason: "not written in the Latin script" },
    { written: "قطر", country: "Qatar", reason: "not written in the Latin script" },
    { written: "Россия", country: "Russia", reason: "not written in the Latin script" },
    { written: "السعودية", country: "Saudi Arabia", reason: "not written in the Latin script" },
    { written: "Србија", country: "Serbia", reason: "not written in the Latin script" },
    { written: "சிங்கப்பூர்", country: "Singapore", reason: "not written in the Latin script" },
    { written: "新加坡", country: "Singapore", reason: "not written in the Latin script" },
    { written: "Saint-Martin", country: "Sint Maarten", reason: "already the name of \"saint martin\"" },
    { written: "الصومال", country: "Somalia", reason: "not written in the Latin script" },
    { written: "한국", country: "South Korea", reason: "not written in the Latin script" },
    { written: "இலங்கை", country: "Sri Lanka", reason: "not written in the Latin script" },
    { written: "ශ්‍රී ලංකාව", country: "Sri Lanka", reason: "not written in the Latin script" },
    { written: "السودان", country: "Sudan", reason: "not written in the Latin script" },
    { written: "سوريا", country: "Syria", reason: "not written in the Latin script" },
    { written: "台灣", country: "Taiwan", reason: "not written in the Latin script" },
    { written: "Таджикистан", country: "Tajikistan", reason: "not written in the Latin script" },
    { written: "Тоҷикистон", country: "Tajikistan", reason: "not written in the Latin script" },
    { written: "ประเทศไทย", country: "Thailand", reason: "not written in the Latin script" },
    { written: "تونس", country: "Tunisia", reason: "not written in the Latin script" },
    { written: "Туркмения", country: "Turkmenistan", reason: "not written in the Latin script" },
    { written: "Україна", country: "Ukraine", reason: "not written in the Latin script" },
    { written: "الإمارات", country: "United Arab Emirates", reason: "not written in the Latin script" },
    { written: "Узбекистан", country: "Uzbekistan", reason: "not written in the Latin script" },
    { written: "الصحراء الغربية", country: "Western Sahara", reason: "not written in the Latin script" },
    { written: "اليمن", country: "Yemen", reason: "not written in the Latin script" },
];

/** The countries in the docblock's last paragraph, as data for whoever closes that half. */
export const unresolvedCountries: readonly string[] = [
    "Algeria",
    "Armenia",
    "Bahrain",
    "Bangladesh",
    "Belarus",
    "Bhutan",
    "Bulgaria",
    "China",
    "Egypt",
    "Ethiopia",
    "Georgia",
    "Greece",
    "Iran",
    "Iraq",
    "Israel",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Libya",
    "Maldives",
    "Mauritania",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Myanmar",
    "Nepal",
    "North Korea",
    "North Macedonia",
    "Oman",
    "Palestine",
    "Qatar",
    "Russia",
    "Saudi Arabia",
    "Serbia",
    "South Korea",
    "Sri Lanka",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Thailand",
    "Tunisia",
    "Ukraine",
    "United Arab Emirates",
    "Yemen",
];
